document.addEventListener("DOMContentLoaded", function () {
  const hcVariants = document.querySelectorAll('.hc-variant');
  hcVariants.forEach(function(hcVariant) {
    hcVariant.addEventListener('click', function() {
      hcVariants.forEach(function(hcVar) {
        hcVar.classList.remove('hc-variant-active');
      });
      this.classList.add('hc-variant-active');

      var hcVariantID = this.getAttribute('data-variant');
      document.querySelector('.product-variant-id').setAttribute('value', hcVariantID);
      var hcVariantTitle = this.getAttribute('data-variant-name');
      document.querySelector('.hc-variant-selected .radio__legend__value').textContent = hcVariantTitle;

      const hcAttributeString = this.getAttribute('data-variant-default');
      const hcAttributes = hcAttributeString.split("/").map(hcAttr => hcAttr.trim());

      hcAttributes.forEach(hcAttr => {
        console.log(hcAttr);
        const hcButton = document.querySelector(`.hc-option-button[data-value="${hcAttr}"]`);
        if (hcButton) {
          hcButton.click();
        }
      });
    });
  });

  document.querySelectorAll('.hc-select').forEach(function (selectEl) {
    selectEl.addEventListener('change', function () {
      var selectedVariantId = this.value;
      var productId = this.getAttribute('data-product');
      var form = document.querySelector('.hc-collection-form[data-product="' + productId + '"]');
      if (form) {
        var input = form.querySelector('input[name="id"]');
        if (input) {
          input.value = selectedVariantId;
        }
      }
    });
  });
});
